module.exports = __webpack_public_path__ + "img/image-10.25a40f48.webp";